import React from 'react';
import { Link } from 'gatsby';
import * as styles from './aiEngineerFellowship.module.scss';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import CrioButton from '@components/v5/CrioButton/index';
import { LEAD_GEN_PLACEMENTS } from '@src/constants/LeadGenerationConstants/index';
import { ERoutes } from '@src/constants/routes/index';
import { useWebEngage } from '@src/hooks/useWebEngage';

const GradsAndStats = ({ content }) => {
  const { logos, stats } = content;
  const { captureUserClickEvent } = useWebEngage();

  // Matches the "Get our Placement Stats" click tracking every other
  // fellowship page sends (see {FspStylePagesYaml.slug}.js,
  // {QaStylePagesYaml.slug}.js) — same WebEngage-via-GTM event, just this
  // page's own placementLocation tag.
  const onPlacementButtonClick = () => {
    captureUserClickEvent('Get our Placement Stats', {
      placementLocation: 'AI_ENGINEER_PAGE',
    });
  };

  return (
    <section id="grads">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Crio Graduates Work At</h2>
        </div>
        <div className={styles.gradLogos}>
          {logos.map((logo) => (
            <div key={logo.title} title={logo.title}>
              <img
                src={logo.src}
                alt={logo.title}
                loading="lazy"
                style={logo.maxHeight ? { maxHeight: logo.maxHeight } : undefined}
              />
            </div>
          ))}
        </div>
        <div className={styles.tiles}>
          {stats.map((stat) => (
            <div className={styles.tile} key={stat.l}>
              <div className={styles.n}>{stat.n}</div>
              <div className={styles.l}>{stat.l}</div>
            </div>
          ))}
        </div>
        <PostContentCTALayout className="mt-8 sm:mt-8">
          <Link to={ERoutes.PLACEMENTS}>
            <CrioButton variant="secondary" onClick={onPlacementButtonClick}>
              Get Our Placement Stats
            </CrioButton>
          </Link>
          <LeadGenerationButton
            text="Apply Now"
            buttonLocation={LEAD_GEN_PLACEMENTS}
            wrapperClassName="shrink-0"
            className="w-auto"
          />
        </PostContentCTALayout>
      </div>
    </section>
  );
};

export default GradsAndStats;
